export default {
  GET_MASTERLIST: (state) => state.masterlist,
  GET_MASTERLIST_ITEM: (state) => state.masterlistItem,
};
